import { render, staticRenderFns } from "./EventosAsistidosCard.vue?vue&type=template&id=3b71a02f"
import script from "./EventosAsistidosCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventosAsistidosCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports